<template>
  <section>
    <h2 class="text-gray-700 text-xl">My Counselor</h2>
    <div class="mt-5 flex">
      <img
        :src="assignee.photo_url || 'https://picsum.photos/seed/picsum/200/300'"
        class="w-10 h-10 rounded-full flex-shrink-0"
      />
      <div class="mx-4">
        <span class="text-black font-medium">{{ assignee.name }} </span>
        <div class="mt-2 flex items-center">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.49534 4.56933L7.66001 0.873327C7.76362 0.811159 7.88218 0.77832 8.00301 0.77832C8.12384 0.77832 8.2424 0.811159 8.34601 0.873327L14.5047 4.56999C14.5541 4.5996 14.595 4.64151 14.6234 4.69164C14.6518 4.74176 14.6667 4.79839 14.6667 4.85599V13.3333C14.6667 13.5101 14.5964 13.6797 14.4714 13.8047C14.3464 13.9298 14.1768 14 14 14H2.00001C1.8232 14 1.65363 13.9298 1.52861 13.8047C1.40358 13.6797 1.33334 13.5101 1.33334 13.3333V4.85533C1.33333 4.79772 1.34825 4.74109 1.37664 4.69097C1.40503 4.64085 1.44593 4.59894 1.49534 4.56933ZM2.66668 5.42199V12.6667H13.3333V5.42133L8.00268 2.22133L2.66668 5.42133V5.42199ZM8.04001 9.13199L11.5707 6.15666L12.4293 7.17666L8.04934 10.868L3.57601 7.18133L4.42401 6.15199L8.04001 9.13199Z"
              fill="#3182CE"
            />
          </svg>
          <span class="ml-1 text-blue-600">
            {{ assignee.email || 'N/A' }}
          </span>
        </div>
        <div class="mt-2 flex items-center">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.244 7.12133C6.86956 8.22032 7.77968 9.13044 8.87867 9.756L9.468 8.93067C9.56277 8.79796 9.7029 8.70459 9.86187 8.66822C10.0208 8.63186 10.1876 8.65502 10.3307 8.73333C11.2735 9.24862 12.3148 9.55852 13.386 9.64267C13.5532 9.65592 13.7092 9.73169 13.823 9.85488C13.9368 9.97807 14 10.1396 14 10.3073V13.282C14 13.4471 13.9388 13.6063 13.8282 13.7288C13.7177 13.8513 13.5655 13.9285 13.4013 13.9453C13.048 13.982 12.692 14 12.3333 14C6.62667 14 2 9.37333 2 3.66667C2 3.308 2.018 2.952 2.05467 2.59867C2.0715 2.43446 2.14866 2.28235 2.27119 2.17176C2.39373 2.06116 2.55294 1.99996 2.718 2H5.69267C5.86037 1.99998 6.02193 2.06317 6.14512 2.17697C6.26831 2.29077 6.34408 2.44682 6.35733 2.614C6.44148 3.68519 6.75138 4.72645 7.26667 5.66933C7.34498 5.81238 7.36814 5.97916 7.33178 6.13813C7.29541 6.2971 7.20204 6.43723 7.06933 6.532L6.244 7.12133ZM4.56267 6.68333L5.82933 5.77867C5.46986 5.00273 5.22357 4.17923 5.098 3.33333H3.34C3.336 3.444 3.334 3.55533 3.334 3.66667C3.33333 8.63733 7.36267 12.6667 12.3333 12.6667C12.4447 12.6667 12.556 12.6647 12.6667 12.66V10.902C11.8208 10.7764 10.9973 10.5301 10.2213 10.1707L9.31667 11.4373C8.95244 11.2958 8.59867 11.1287 8.258 10.9373L8.21933 10.9153C6.91172 10.1711 5.82885 9.08828 5.08467 7.78067L5.06267 7.742C4.87127 7.40133 4.70419 7.04756 4.56267 6.68333Z"
              fill="#4A5568"
            />
          </svg>

          <span class="ml-1 text-gray-700 text-sm">
            {{ assignee.phone_number || 'N/A' }}
          </span>
        </div>
        <div class="mt-2 flex items-center">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 13.9339L11.3 10.6339C11.9526 9.98127 12.397 9.14975 12.577 8.24452C12.7571 7.33928 12.6646 6.401 12.3114 5.5483C11.9582 4.69561 11.36 3.9668 10.5926 3.45404C9.82519 2.94129 8.92296 2.6676 8 2.6676C7.07704 2.6676 6.17481 2.94129 5.40739 3.45404C4.63997 3.9668 4.04183 4.69561 3.68861 5.5483C3.33539 6.401 3.24294 7.33928 3.42297 8.24452C3.603 9.14975 4.04741 9.98127 4.7 10.6339L8 13.9339ZM8 15.8193L3.75734 11.5766C2.91823 10.7375 2.34679 9.66838 2.11529 8.5045C1.88378 7.34061 2.0026 6.13422 2.45673 5.03787C2.91086 3.94151 3.6799 3.00445 4.66659 2.34516C5.65328 1.68588 6.81332 1.33398 8 1.33398C9.18669 1.33398 10.3467 1.68588 11.3334 2.34516C12.3201 3.00445 13.0891 3.94151 13.5433 5.03787C13.9974 6.13422 14.1162 7.34061 13.8847 8.5045C13.6532 9.66838 13.0818 10.7375 12.2427 11.5766L8 15.8193ZM8 8.66727C8.35362 8.66727 8.69276 8.52679 8.94281 8.27674C9.19286 8.02669 9.33334 7.68755 9.33334 7.33393C9.33334 6.98031 9.19286 6.64117 8.94281 6.39112C8.69276 6.14108 8.35362 6.0006 8 6.0006C7.64638 6.0006 7.30724 6.14108 7.05719 6.39112C6.80715 6.64117 6.66667 6.98031 6.66667 7.33393C6.66667 7.68755 6.80715 8.02669 7.05719 8.27674C7.30724 8.52679 7.64638 8.66727 8 8.66727ZM8 10.0006C7.29276 10.0006 6.61448 9.71965 6.11438 9.21955C5.61429 8.71945 5.33334 8.04118 5.33334 7.33393C5.33334 6.62669 5.61429 5.94841 6.11438 5.44831C6.61448 4.94822 7.29276 4.66727 8 4.66727C8.70725 4.66727 9.38552 4.94822 9.88562 5.44831C10.3857 5.94841 10.6667 6.62669 10.6667 7.33393C10.6667 8.04118 10.3857 8.71945 9.88562 9.21955C9.38552 9.71965 8.70725 10.0006 8 10.0006Z"
              fill="#4A5568"
            />
          </svg>

          <span class="ml-1 text-gray-700 text-sm">
            {{ assignee.address || 'N/A' }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
export default {
  name: 'DashboardSidebar',
  created() {
    axios
      .get('/api/profile')
      .then(res => res.data)
      .then(data => {
        this.assignee = data.assignee;
      });
  },
  data() {
    return {
      assignee: {}
    };
  }
};
</script>
